export default "__VITE_ASSET__CEqNtA1u__"